import { graphql, useStaticQuery } from "gatsby";
import GatsbyImage from "gatsby-image";
import { get } from "lodash";
import React from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import Parallax from "./Parallax";
import PuppyGIF from "../images/2024-feeding-greatness.png";
import { css } from "@emotion/core";
import { OutboundLink } from "gatsby-plugin-google-analytics";
export default function ParallaxPuppy() {
  const { logo, file } = useStaticQuery(graphql`
    {
      file(relativePath: { regex: "/parallax-puppy-background-blank.jpg/" }) {
        childImageSharp {
          fluid(quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logo: file(absolutePath: { regex: "/2024-feeding-greatness.png/" }) {
        s: childImageSharp {
          fluid {
            presentationWidth
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <OutboundLink href="https://bit.ly/3eRimzY" target="_blank">
    <Parallax image={file}>
      
        <img src={PuppyGIF} alt="Product range promo"
          style={{
            margin: "0px auto",
            maxWidth: "810px",
            maxHeight: "340px",
            width:"90%",
            height:"auto"
          }}></img>
          
    </Parallax>
    </OutboundLink>
  );
}